import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { AIGretaAskButton } from '../../../AIGreta'
import { RequestWizardAIWizardFilledChip } from '../RequestWizardAIWizardFilledChip'
import { QA_NAME_REQUEST_WIZARD_AI_WIZARD_BUTTON } from '../RequestWizardForm.constants'

import * as styles from './RequestWizardAIWizardButton.module.css'

function RequestWizardAIWizardButton({
  isFilled,
  isLoading,
  isSubmitting,
  onGenerate,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      {isFilled ? <RequestWizardAIWizardFilledChip /> : null}
      <AIGretaAskButton
        disabled={isSubmitting}
        isLoading={isLoading}
        qaName={QA_NAME_REQUEST_WIZARD_AI_WIZARD_BUTTON}
        tooltip={t('Wizard.AIWizardButtonTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onGenerate}
      />
    </div>
  )
}

export default RequestWizardAIWizardButton
